export const STORAGE_BUCKETS = {
    PUBLIC: "https://codepro-public.s3.ir-thr-at1.arvanstorage.ir",
    PRIVATE: "https://codepro-private.s3.ir-thr-at1.arvanstorage.ir",
} as const;

export const IMAGE_BREAKPOINTS = {
    DESKTOP: "(min-width: 1024px)",
    TABLET: "(min-width: 600px) and (max-width: 1023px)",
    MOBILE: "(max-width: 599px)",
} as const;

export const IMAGE_MIME_TYPE = "image/webp";
